<template>
    <div class="table-responsive table-wrapper">
        <div v-if="loading" class="text-center p-4">
            <i class="fa fa-spinner fa-spin fa-2x"></i>
        </div>
        <table v-else class="table table-bordered custom-table mb-0">
            <thead class="thead-custom">
                <tr>
                    <th class="sticky-col col-item text-center">Item</th>
                    <th class="sticky-col col-desc">Descrição</th>
                    <th class="sticky-col col-contrato text-center">Contrato</th>
                    <th class="sticky-col col-situacao text-center border-right-0">Situação</th>
                    <th class="sticky-col col-tipo text-center border-left-0"></th>
                    <th class="sticky-col col-acumulado text-center">Acumulado</th>
                    <th v-for="index in listaIndicesBms" :key="`header-bm-${index}`" class="text-center min-w-bm">
                        BM {{ index + 1 | formatarNumero }}
                    </th>
                </tr>
            </thead>

            <tbody v-for="item in itensExibicao" :key="item.id">
                <tr>
                    <td :rowspan="rowspanItem" class="align-middle text-center sticky-col col-item bg-white weight-600">
                        {{ obterItemPai(item) }}
                    </td>
                    <td :rowspan="rowspanItem" class="align-middle sticky-col col-desc bg-white">
                        <div class="truncate-text" v-b-tooltip.hover :title="item.descricao">
                            {{ item.descricao }}
                        </div>
                    </td>
                    <td :rowspan="rowspanItem" class="align-middle text-center sticky-col col-contrato bg-white">
                        {{ item.valorTotalItem | currency }}
                    </td>

                    <td rowspan="2" class="align-middle sticky-col col-situacao bg-gray-standard">Planejado</td>
                    <td class="sticky-col col-tipo bg-gray-standard">Parcial</td>
                    <td class="sticky-col col-acumulado bg-white text-right weight-600">
                        {{ item.planejado.acumulado.valor | currency }}
                    </td>
                    <td v-for="index in listaIndicesBms" :key="`plan-val-${index}`" class="text-right">
                        <span v-if="obterDadosPeriodo(item.planejado, index)">
                            {{ obterDadosPeriodo(item.planejado, index).valor | currency }}
                        </span>
                        <span v-else class="text-muted">-</span>
                    </td>
                </tr>
                <tr>
                    <td class="sticky-col col-tipo bg-gray-standard">Percentual</td>
                    <td class="sticky-col col-acumulado bg-white text-right weight-600">
                        {{ item.planejado.acumulado.percentual | percentual }}
                    </td>
                    <td v-for="index in listaIndicesBms" :key="`plan-pct-${index}`" class="text-right">
                        <span v-if="obterDadosPeriodo(item.planejado, index)">
                            {{ obterDadosPeriodo(item.planejado, index).percentual | percentual }}
                        </span>
                        <span v-else class="text-muted">-</span>
                    </td>
                </tr>
                <tr v-if="exibirRealizado">
                    <td rowspan="2" class="align-middle sticky-col col-situacao bg-gray-standard">Realizado</td>
                    <td class="sticky-col col-tipo bg-gray-standard">Parcial</td>
                    <td class="sticky-col col-acumulado bg-white text-right weight-600">
                        {{ item.realizado.acumulado.valor | currency }}
                    </td>
                    <td v-for="index in listaIndicesBms" :key="`real-val-${index}`" class="text-right">
                        <span v-if="obterDadosPeriodo(item.realizado, index)">
                            {{ obterDadosPeriodo(item.realizado, index).valor | currency }}
                        </span>
                        <span v-else class="text-muted">-</span>
                    </td>
                </tr>
                <tr>
                    <td v-if="exibirRealizado" class="sticky-col col-tipo bg-gray-standard">Percentual</td>
                    <td v-if="exibirRealizado" class="sticky-col col-acumulado bg-white text-right weight-600">
                        {{ item.realizado.acumulado.percentual | percentual }}
                    </td>
                    <td v-if="exibirRealizado" v-for="index in listaIndicesBms" :key="`real-pct-${index}`" class="text-right">
                        <span v-if="obterDadosPeriodo(item.realizado, index)">
                            {{ obterDadosPeriodo(item.realizado, index).percentual | percentual }}
                        </span>
                        <span v-else class="text-muted">-</span>
                    </td>
                </tr>
            </tbody>

            <tbody v-if="totalExibicao && totalExibicao.planejado">
                <tr class="bg-gray-standard weight-600">
                    <td colspan="3" :rowspan="rowspanTotal" class="align-middle pl-4 sticky-col col-total-geral">
                        Total Geral Financeiro
                    </td>
                    <td rowspan="3" class="align-middle sticky-col col-situacao bg-gray-standard">Planejado</td>
                    <td class="sticky-col col-tipo bg-gray-standard">Parcial</td>
                    <td class="sticky-col col-acumulado bg-gray-standard text-right">
                        {{ totalExibicao.planejado.acumulado.parcial | currency }}
                    </td>
                    <td v-for="index in listaIndicesBms" :key="`tot-plan-val-${index}`" class="text-right">
                        <span v-if="obterDadosPeriodo(totalExibicao.planejado, index)">
                            {{ obterDadosPeriodo(totalExibicao.planejado, index).parcial | currency }}
                        </span>
                        <span v-else>-</span>
                    </td>
                </tr>
                <tr class="bg-gray-standard weight-600">
                    <td class="sticky-col col-tipo bg-gray-standard">Acumulado</td>
                    <td class="sticky-col col-acumulado bg-gray-standard text-right">
                        {{ totalExibicao.planejado.acumulado.acumulado | currency }}
                    </td>
                    <td v-for="index in listaIndicesBms" :key="`tot-plan-acum-${index}`" class="text-right">
                        <span v-if="obterDadosPeriodo(totalExibicao.planejado, index)">
                            {{ obterDadosPeriodo(totalExibicao.planejado, index).acumulado | currency }}
                        </span>
                        <span v-else>-</span>
                    </td>
                </tr>
                <tr class="bg-gray-standard weight-600">
                    <td class="sticky-col col-tipo bg-gray-standard">Percentual</td>
                    <td class="sticky-col col-acumulado bg-gray-standard text-right">
                        {{ totalExibicao.planejado.acumulado.percentual | percentual }}
                    </td>
                    <td v-for="index in listaIndicesBms" :key="`tot-plan-pct-${index}`" class="text-right">
                        <span v-if="obterDadosPeriodo(totalExibicao.planejado, index)">
                            {{ obterDadosPeriodo(totalExibicao.planejado, index).percentual | percentual }}
                        </span>
                        <span v-else>-</span>
                    </td>
                </tr>

                <tr v-if="exibirRealizado && totalExibicao.realizado" class="bg-gray-standard weight-600">
                    <td rowspan="3" class="align-middle sticky-col col-situacao bg-gray-standard">Realizado</td>
                    <td class="sticky-col col-tipo bg-gray-standard">Parcial</td>
                    <td class="sticky-col col-acumulado bg-gray-standard text-right">
                        {{ totalExibicao.realizado.acumulado.parcial | currency }}
                    </td>
                    <td v-for="index in listaIndicesBms" :key="`tot-real-val-${index}`" class="text-right">
                        <span v-if="obterDadosPeriodo(totalExibicao.realizado, index)">
                            {{ obterDadosPeriodo(totalExibicao.realizado, index).parcial | currency }}
                        </span>
                        <span v-else>-</span>
                    </td>
                </tr>
                <tr v-if="exibirRealizado && totalExibicao.realizado" class="bg-gray-standard weight-600">
                    <td class="sticky-col col-tipo bg-gray-standard">Acumulado</td>
                    <td class="sticky-col col-acumulado bg-gray-standard text-right">
                        {{ totalExibicao.realizado.acumulado.acumulado | currency }}
                    </td>
                    <td v-for="index in listaIndicesBms" :key="`tot-real-acum-${index}`" class="text-right">
                        <span v-if="obterDadosPeriodo(totalExibicao.realizado, index)">
                            {{ obterDadosPeriodo(totalExibicao.realizado, index).acumulado | currency }}
                        </span>
                        <span v-else>-</span>
                    </td>
                </tr>
                <tr v-if="exibirRealizado && totalExibicao.realizado" class="bg-gray-standard weight-600">
                    <td class="sticky-col col-tipo bg-gray-standard">Percentual</td>
                    <td class="sticky-col col-acumulado bg-gray-standard text-right">
                        {{ totalExibicao.realizado.acumulado.percentual | percentual }}
                    </td>
                    <td v-for="index in listaIndicesBms" :key="`tot-real-pct-${index}`" class="text-right">
                        <span v-if="obterDadosPeriodo(totalExibicao.realizado, index)">
                            {{ obterDadosPeriodo(totalExibicao.realizado, index).percentual | percentual }}
                        </span>
                        <span v-else>-</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import BoletimMedicaoServicos from '../../../BoletimMedicaoServicos';

export default {
    name: 'BoletimMedicaoCronogramaTable',
    props: {
        listaItens: { type: Array, default: () => [] },
        dadosTotal: { type: Object, default: () => ({}) },
        indiceFixoBm: { type: [String, Number], default: 0 },
        exibirTodosBms: { type: Boolean, default: false },
        exibirRealizado: { type: Boolean, default: true },
        contratoId: { type: [Number, String], default: 0 },
        boletimMedicaoId: { type: [Number, String], default: 0 },
        listaBoletins: { type: Array, default: () => [] }
    },
    data() {
        return {
            loading: false,
            itensInternos: [],
            totalInterno: null,
            dadosContrato: null,
            numeroBoletimInterno: 0,
            listaBoletinsInternal: []
        }
    },
    computed: {
        itensExibicao() {
            let itens = [];
            if (this.listaItens && this.listaItens.length > 0) {
                itens = [...this.listaItens];
            } else if (this.itensInternos && this.itensInternos.length > 0) {
                itens = [...this.itensInternos];
            }

            return itens.sort((a, b) => {
                const valA = this.obterValorOrdenacaoItem(a);
                const valB = this.obterValorOrdenacaoItem(b);
                const comparacaoCodigo = String(valA).localeCompare(String(valB), undefined, { numeric: true, sensitivity: 'base' });
                if (comparacaoCodigo !== 0) return comparacaoCodigo;

                return String(a.descricao || '').localeCompare(String(b.descricao || ''), undefined, { numeric: true, sensitivity: 'base' });
            });
        },
        totalExibicao() {
            if (this.dadosTotal && (this.dadosTotal.planejado || this.dadosTotal.realizado)) return this.dadosTotal;
            if (this.totalInterno) return this.totalInterno;
            return {};
        },
        indiceTratado() {
            const bmNum = this.numeroBoletimInterno || this.indiceFixoBm;
            if (!bmNum) return 0;
            if (typeof bmNum === 'number') return bmNum > 0 ? bmNum - 1 : 0;

            const str = String(bmNum);
            const apenasDigitos = str.replace(/\D/g, '');
            const numero = parseInt(apenasDigitos, 10);

            return numero > 0 ? numero - 1 : 0;
        },
        listaIndicesBms() {
            if (!this.exibirTodosBms) {
                return [this.indiceTratado];
            }

            const lista = this.listaBoletins.length > 0
                ? this.listaBoletins
                : this.listaBoletinsInternal;

            if (lista.length > 0) {
                return lista.map(bm => bm - 1).sort((a, b) => a - b);
            }

            let max = 0;
            if (this.itensExibicao && this.itensExibicao.length > 0) {
                this.itensExibicao.forEach(item => {
                    if (item.planejado && item.planejado.bms && Array.isArray(item.planejado.bms)) {
                        if (item.planejado.bms.length > max) max = item.planejado.bms.length;
                    }
                    if (item.realizado && item.realizado.bms && Array.isArray(item.realizado.bms)) {
                        if (item.realizado.bms.length > max) max = item.realizado.bms.length;
                    }
                });
            }
            if (max === 0 && this.totalExibicao) {
                if (this.totalExibicao.planejado && this.totalExibicao.planejado.bms && Array.isArray(this.totalExibicao.planejado.bms)) {
                    if (this.totalExibicao.planejado.bms.length > max) max = this.totalExibicao.planejado.bms.length;
                }
            }

            return Array.from({length: max}, (_, i) => i);
        },
        rowspanItem() {
            return this.exibirRealizado ? 4 : 2;
        },
        rowspanTotal() {
             return this.exibirRealizado ? 6 : 3;
        }
    },
    watch: {
        contratoId() {
            this.carregarDados();
        },
        boletimMedicaoId() {
            this.carregarDados();
        }
    },
    mounted() {
        this.carregarDados();
    },
    methods: {
        normalizarCodigoItem(codigo) {
            if (codigo === null || codigo === undefined) return '';

            const texto = String(codigo).trim();
            if (!texto) return '';

            const match = texto.match(/^\d+(?:\.\d+)*\.?/);
            if (!match) return '';

            return match[0].replace(/\.$/, '');
        },
        extrairCodigoDescricao(descricao) {
            return this.normalizarCodigoItem(descricao);
        },
        obterCodigoBaseItem(item = {}) {
            const codigoHierarquia = this.normalizarCodigoItem(item.codigoHierarquia);
            if (codigoHierarquia) return codigoHierarquia;

            const codigoDireto = this.normalizarCodigoItem(item.item || item.ordem || item.seqRM);
            if (codigoDireto) return codigoDireto;

            const codigoDescricao = this.extrairCodigoDescricao(item.descricao);
            if (codigoDescricao) return codigoDescricao;

            return '';
        },
        obterItemPai(item = {}) {
            const codigo = this.obterCodigoBaseItem(item);
            if (!codigo) return '-';

            return codigo.split('.')[0];
        },
        obterValorOrdenacaoItem(item = {}) {
            const codigo = this.obterCodigoBaseItem(item);
            if (codigo) return codigo;

            return String(item.descricao || '');
        },
        carregarDados() {
            if (!this.contratoId || !this.boletimMedicaoId) return;

            this.loading = true;
            BoletimMedicaoServicos.obterPlanejamentoFisicoFinanceiro(this.contratoId, this.boletimMedicaoId)
                .then(response => {
                    if (response && response.success) {
                        const dados = response.data;
                        this.dadosContrato = dados.contrato || {
                            valorTotal: dados.valorTotalContrato,
                            gestor: dados.gestor,
                            dataVigencia: dados.vigencia
                        };

                        this.numeroBoletimInterno = dados.numeroBoletim;
                        this.listaBoletinsInternal = dados.listaBoletins || [];
                        this.itensInternos = this.garantirEstruturaItens(dados.itens, dados.numeroBoletim);
                        this.totalInterno = this.garantirEstruturaTotal(dados.total, this.itensInternos, dados.numeroBoletim);
                    } else {
                        this.itensInternos = [];
                        this.totalInterno = null;
                        this.numeroBoletimInterno = 0;
                    }
                })
                .catch(error => {
                    console.error("Erro ao carregar planejamento:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        obterDadosPeriodo(objDados, index) {
            const idx = (index !== undefined) ? index : this.indiceTratado;

            if (!objDados) return null;
            if (objDados.bms && Array.isArray(objDados.bms)) {
                return objDados.bms[idx];
            }
            return null;
        },
        formatarPercentual(valor) {
            if (valor === undefined || valor === null) return 0;
            const num = parseFloat(valor);
            return isNaN(num) ? 0 : parseFloat(num.toFixed(2));
        },
        garantirEstruturaItens(itens, numeroBoletim) {
            if (!itens || !Array.isArray(itens)) return [];

            return itens.map(item => {
                const bmsPlanejado = [];
                const bmsRealizado = [];

                if (item.historicoMedicoes && Array.isArray(item.historicoMedicoes)) {
                    item.historicoMedicoes.forEach(hist => {
                        const idx = hist.numeroBoletim - 1;
                        if (idx >= 0) {
                            bmsPlanejado[idx] = {
                                valor: hist.valorPlanejado || 0,
                                percentual: this.formatarPercentual(hist.percentualPlanejado)
                            };
                            bmsRealizado[idx] = {
                                valor: hist.valorExecutado || 0,
                                percentual: this.formatarPercentual(hist.percentualExecutado)
                            };
                        }
                    });
                } else {
                    const targetIdx = numeroBoletim ? numeroBoletim - 1 : this.indiceTratado;
                    
                    if (item.valorPlanejado !== undefined || item.valorExecutado !== undefined) {
                        bmsPlanejado[targetIdx] = {
                            valor: item.valorPlanejado || 0,
                            percentual: this.formatarPercentual(item.percentualPlanejado)
                        };

                        bmsRealizado[targetIdx] = {
                            valor: item.valorExecutado || 0,
                            percentual: this.formatarPercentual(item.percentualExecutado)
                        };
                    }
                }

                const codigoHierarquia = this.obterCodigoBaseItem(item);

                return {
                    id: item.itemPlanejamentoId || item.itemContratoId,
                    itemContratoId: item.itemContratoId,
                    codigoHierarquia,
                    descricao: item.descricao,
                    valorTotalItem: item.valorTotalItem || item.saldoValor,
                    contrato: item.contrato || '',
                    planejado: {
                        acumulado: {
                            valor: item.valorAcumuladoPlanejamento || 0,
                            percentual: this.formatarPercentual(item.percentualAcumuladoPlanejamento)
                        },
                        bms: bmsPlanejado
                    },
                    realizado: {
                        acumulado: {
                            valor: item.valorAcumuladoExecutado || 0,
                            percentual: this.formatarPercentual(item.percentualAcumuladoExecutado)
                        },
                        bms: bmsRealizado
                    }
                };
            });
        },
        garantirEstruturaTotal(total, itensMapeados, numeroBoletim) {
            if (total && total.planejado && total.realizado && (total.realizado.acumulado.parcial > 0 || total.realizado.bms.length > 0)) return total;

            const valorTotalContrato = this.dadosContrato ? (this.dadosContrato.valorTotal || this.dadosContrato.valorTotalContrato || 0) : 0;

            const totalValorAcumuladoPlan = itensMapeados.reduce((acc, it) => acc + (it.planejado.acumulado.valor || 0), 0);
            const totalPctAcumuladoPlan = valorTotalContrato ? (totalValorAcumuladoPlan / valorTotalContrato) * 100 : 0;

            const totalValorAcumuladoReal = itensMapeados.reduce((acc, it) => acc + (it.realizado.acumulado.valor || 0), 0);
            const totalPctAcumuladoReal = valorTotalContrato ? (totalValorAcumuladoReal / valorTotalContrato) * 100 : 0;

            const bmsPlanTotal = [];
            const bmsRealTotal = [];

            let maxBms = 0;
            if (numeroBoletim && numeroBoletim > maxBms) maxBms = numeroBoletim; 
            
            itensMapeados.forEach(it => {
                if (it.planejado && it.planejado.bms && it.planejado.bms.length > maxBms) maxBms = it.planejado.bms.length;
            });

            for (let i = 0; i < maxBms; i++) {
                 const valParcialPlan = itensMapeados.reduce((acc, it) => acc + (it.planejado.bms[i] ? it.planejado.bms[i].valor : 0), 0);
                 const pctParcialPlan = valorTotalContrato ? (valParcialPlan / valorTotalContrato) * 100 : 0;
                 
                 const previousAcumPlan = (i > 0 && bmsPlanTotal[i-1]) ? bmsPlanTotal[i-1].acumulado : 0;
                 const currentAcumPlan = previousAcumPlan + valParcialPlan;

                 bmsPlanTotal[i] = {
                    parcial: valParcialPlan,
                    acumulado: currentAcumPlan,
                    percentual: this.formatarPercentual(pctParcialPlan)
                 };

                 const valParcialReal = itensMapeados.reduce((acc, it) => acc + (it.realizado.bms[i] ? it.realizado.bms[i].valor : 0), 0);
                 const pctParcialReal = valorTotalContrato ? (valParcialReal / valorTotalContrato) * 100 : 0;
                 
                 const previousAcumReal = (i > 0 && bmsRealTotal[i-1]) ? bmsRealTotal[i-1].acumulado : 0;
                 const currentAcumReal = previousAcumReal + valParcialReal;

                 bmsRealTotal[i] = {
                    parcial: valParcialReal,
                    acumulado: currentAcumReal,
                    percentual: this.formatarPercentual(pctParcialReal)
                 };
            }

            return {
                planejado: {
                    acumulado: {
                        parcial: totalValorAcumuladoPlan, 
                        acumulado: totalValorAcumuladoPlan,
                        percentual: this.formatarPercentual(totalPctAcumuladoPlan)
                    },
                    bms: bmsPlanTotal
                },
                realizado: {
                    acumulado: {
                        parcial: totalValorAcumuladoReal,
                        acumulado: totalValorAcumuladoReal,
                        percentual: this.formatarPercentual(totalPctAcumuladoReal)
                    },
                    bms: bmsRealTotal
                }
            };
        }
    },
    filters: {
        currency(value) {
            if (value === null || value === undefined) return 'R$ 0,00'
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
        formatarNumero(value) {
            if(!value) return '00';
            return String(value).padStart(2, '0');
        }
    }
}
</script>

<style scoped>
.table-wrapper {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
    width: 100%;
    box-shadow: 0 0 5px rgba(0,0,0,0.1);
}
.custom-table {
    font-size: 0.85rem;
    width: max-content;
    min-width: 100%;
    border-collapse: separate;
    border-spacing: 0;
}
.custom-table th, .custom-table td {
    vertical-align: middle;
    padding: 0.5rem;
    white-space: nowrap;
    border: 1px solid #ced4da;
    background-clip: padding-box;
}
.bg-gray-standard, .thead-custom th {
    background-color: #e2e3e5 !important;
    color: #25282A;
}
.bg-white { background-color: #fff !important; }
.min-w-bm { min-width: 130px; }
.truncate-text {
    max-width: 250px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.sticky-col { position: sticky; z-index: 2; }
.thead-custom th.sticky-col { z-index: 3; }
.col-item { left: 0; width: 35px; border-right: 1px solid #ced4da; }
.col-desc { left: 35px; width: 170px; border-right: 1px solid #ced4da; }
.col-contrato { left: 205px; width: 75px; border-right: 1px solid #ced4da; }
.col-situacao { left: 280px; width: 75px; border-right: 1px solid #ced4da; }
.col-tipo { left: 355px; width: 70px; border-right: 1px solid #ced4da; }
.col-acumulado { left: 425px; width: 95px; border-right: 2px solid #aaa !important; z-index: 2; box-shadow: 2px 0 5px rgba(0,0,0,0.1); }
.thead-custom th.col-acumulado { z-index: 3; background-color: #e2e3e5 !important; }
.col-total-geral { left: 0; width: 280px; z-index: 3; background-color: #e2e3e5 !important; border-right: 1px solid #ced4da; }

/* Weight utilities */
.weight-600 { font-weight: 600 !important; }
.weight-400 { font-weight: 400 !important; }

/* thead should not be excessively bold */
.thead-custom th {
    font-weight: 600;
}
</style>